import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ListaComponent} from "./pages/lista/lista.component";
import {NovoComponent} from "./pages/novo/novo.component";
import {DetalhesComponent} from "./pages/detalhes/detalhes.component";
import {VisualizarProcessoComponent} from "./pages/visualizar-processo/visualizar-processo.component";

const routes: Routes = [
  { path: "", component: ListaComponent },
  { path: "novo", component: NovoComponent },
  { path: "detalhes/:id", component: DetalhesComponent },
  { path: "visualizar/:id", component: VisualizarProcessoComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProcessoRoutingModule { }
